module.exports = __webpack_public_path__ + "img/avatar.602e2eeb.svg";